import { render, staticRenderFns } from "./TenderOpportunities.vue?vue&type=template&id=03511804"
import script from "./TenderOpportunities.vue?vue&type=script&lang=js"
export * from "./TenderOpportunities.vue?vue&type=script&lang=js"
import style0 from "./TenderOpportunities.vue?vue&type=style&index=0&id=03511804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports